/** @odoo-module **/

import {Component, mount, xml, useState, useEffect, useRef, onWillStart} from "@odoo/owl";
//import { useService } from "@web/core/utils/hooks";



export class WPCPortalLogin extends Component {
    static template = 'wpc_portal.login'
    static components = {
    }
    static defaultProps = {
    }
    setup() {
        var self = this;
        //self.wpc_auth = useService("wpc_auth");
//        self.wpc_auth = wpc_auth;
        self.state = useState({
            email: '',
            password: '',
            signupPassword: '',
            signupPasswordConfirm: '',
            lastErrorMessage: '',
            lastSignupErrorMessage: '',
            step: 'cred',
            cred_type: 'login',
            roles: [],
        })
        if (this.props.page_params.page == 'change_password' && this.props.page_params.confirmation_code && this.props.page_params.confirmation_code.length) {
            this.state.cred_type = 'change_password';
            $.ajax({url: '/auth/forgot/info', dataType: 'json', type:'POST', data: {
                password: self.state.password,
                confirmation_code: self.props.page_params.confirmation_code,
            }}).then((result)=> {
                if (result.success){
                    this.state.email = result.email;
                }
                else{
                    this.state.lastErrorMessage = result.message
                    this.state.cred_type = 'login';
                    // window.location.hash = '';
                }
            });
        }
    }

    doLogin() {
        var self = this;
        self.state.lastErrorMessage = '';
        self.wpc_auth_login(self.env.wpc_state, this.state.email, this.state.password)
        .then((result)=>{
        console.log('wpc_auth_login result', result);
            self.state.step = result.step;
            self.state.roles = result.roles;
            if (result.step === 'role'){

            }
            else if (result.success === true) {
                self.env.refresh_login_status();
            }
            else {
                self.env.refresh_login_status();  // TODO: Remove line, not needed
                self.state.lastErrorMessage = result.message;
            }
        }).fail((err)=>{
            self.state.lastErrorMessage = `Unknown Error: ${err.statusText}`
        })
    }

    doChangePassword(){
        var self = this;
        self.state.lastErrorMessage = '';
        if (!self.state.password || !self.state.password2){
            self.state.lastErrorMessage = 'Please enter a new password';
            return;
        }
        if (self.state.password !== self.state.password2){
            self.state.lastErrorMessage = 'Password does not match';
            return;
        }

        $.ajax({url: '/auth/change_password', dataType: 'json', type:'POST', data: {
            password: self.state.password,
            confirmation_code: self.props.page_params.confirmation_code,
        }}).then((result)=>{
            console.log('wpc_auth_login result', result);
            self.state.step = result.step;
            self.state.roles = result.roles;
            if (result.success === true) {
                self.env.refresh_login_status();
                self.state.cred_type = 'login';
                self.state.lastErrorMessage = 'Your password has been changed.';
                window.location.hash = '';
            }
            else {
                self.env.refresh_login_status();  // TODO: Remove line, not needed
                self.state.lastErrorMessage = result.message;
            }
        }).fail((err)=>{
            self.state.lastErrorMessage = `Unknown Error: ${err.statusText}`
        })
    }

    selectRole(role) {
        var self = this;
        $.ajax({url: '/auth/select_role', dataType: 'json', type:'POST', data: {
            uid: role.uid,
        }})
        .then((data)=>{
            if (data.success) {
                self.env.refresh_login_status();
            }
            else {
                self.env.refresh_login_status();  // TODO: Remove line, not needed
                self.state.lastErrorMessage = result.message;
            }
        })
        console.log('ROLE SELECTED', role);
    }

    onForgotPassword() {
        var self = this;
        self.state.lastErrorMessage = '';
        return $.ajax({url: '/auth/forgot', dataType: 'json', type:'POST', data: {
            email: self.state.email,
        }}).then((_)=>{
            self.state.cred_type = 'forgot_success'
        }).fail((err)=>{
            self.state.lastErrorMessage = `Unknown Error: ${err.statusText}`
        })
    }

    onSendEmailCode(){
        var self = this;
        self.state.lastErrorMessage = '';
        return $.ajax({url: '/auth/email/verify/send', dataType: 'json', type:'POST', data: {
            verify_code: self.state.email_code,
        }}).then((o)=>{
            console.log('onVerifyEmail', o);
            if (!o.success && o.message){
                self.state.lastErrorMessage = o.message;
            }
            else if(o.success) {
                self.env.refresh_login_status();
            }
            // self.state.cred_type = 'forgot_success'
        }).fail((err)=>{
            self.state.lastErrorMessage = `Unknown Error: ${err.statusText}`
        })

    }

    onVerifyEmail(){
        var self = this;
        self.state.lastErrorMessage = '';
        return $.ajax({url: '/auth/verify', dataType: 'json', type:'POST', data: {
            verify_code: self.state.email_code,
        }}).then((o)=>{
            console.log('onVerifyEmail', o);
            if (!o.success && o.message){
                self.state.lastErrorMessage = o.message;
                if (o.step && o.step !== 'verify'){
                    // Session no longer at the verify step, resync the UI off the stale form
                    self.env.refresh_login_status();
                }
            }
            else if(o.success) {
                self.env.refresh_login_status();
            }
            // self.state.cred_type = 'forgot_success'
        }).fail((err)=>{
            self.state.lastErrorMessage = `Unknown Error: ${err.statusText}`
        })
    }

    onSubmitSignup(event) {
        this.state.saving = true;
        const form = event.target;
        const formData = new FormData(form);

        const data = Object.fromEntries(formData.entries());

        // console.log('PASSWORD', this.state.signupPassword, this.state.signupPasswordConfirm, this.state.signupPassword.length);

        if (!this.state.signupPassword || !this.state.signupPassword.length){
            this.state.lastSignupErrorMessage = 'Please enter a password';
            this.state.saving = false;
            return;
        }
        else if (this.state.signupPassword !== this.state.signupPasswordConfirm || !this.state.signupPassword.length){
            this.state.lastSignupErrorMessage = 'Password does not match.';
            this.state.saving = false;
            return;
        }

        this.state.lastSignupErrorMessage = '';

        $.ajax({url: '/auth/signup', dataType: 'json', type:'POST', data:
            {...data},
        }).then(res=>{
            if (!res || !res.success){
                this.state.lastSignupErrorMessage = res.message;
                this.state.saving = false;
                return;
            }
            else {
                this.state.saving = false;
                window.location.reload()
            }
        }).catch(err=>{
            this.state.lastSignupErrorMessage = err.message;
            console.log(err);
            alert(JSON.stringify(err));
            this.state.saving = false;
        })
    }

    wpc_auth_login(wpc_state, username, password) {
        return $.ajax({url: '/auth/login', dataType: 'json', type:'POST', data: {
            username: username,
            password: password,
//            csrf_token: odoo.csrf_token,
        }});
    }

    doLogout() {
        var self = this;
//        self.state.lastErrorMessage = '';
        $.ajax({
            url: '/auth/logout', dataType: 'json', type: 'POST', data: {
                // csrf_token: odoo.csrf_token,
            }
        })
        .then((result) => {
            self.env.refresh_login_status();
        }).fail((err) => {
            debugger;
        })
    }
}
